export default "__VITE_ASSET__TAkO2izF__"